import React, { useContext, useRef, useState } from 'react'
import './Box.css'
import axios from 'axios';
import { toast } from 'react-toastify';
import Globalcontext from '../../Context/Globalcontext';
import Status from "../../imgs/statusmob.jpeg";
import { useTranslation } from "react-i18next";

const Box = (props) => {

  const { setNewcustsource, setSanksource, setHeadname } = useContext(Globalcontext);

  const [t] = useTranslation();

  const [input, setInput] = useState({ pass: "" });

  const refdelete = useRef(null);
  const refdeleteclose = useRef(null);
  const refchpass = useRef(null);
  const refchpassclose = useRef(null);

  const notify = (msg) => toast(msg);
  const notifyerror = (msg) => toast.error(msg);

  const handleChange = (event) => {
    const name = event.target.name;
    const valuecurrent = event.target.value;
    setInput(value => ({ ...value, [name]: valuecurrent }))
  }

  const handledeleteclose = () => {
    refdeleteclose.current?.click();
  }

  const handledelete = () => {
    refdelete.current?.click();
  }

  const handlechpassclose = () => {
    refchpassclose.current?.click();
  }

  const handlechpass = () => {
    refchpass.current?.click();
  }

  var jsEncode = {
    encode: function (s, k) {
      var enc = "";
      var str = s.toString();
      for (var i = 0; i < str.length; i++) {
        var a = str.charCodeAt(i);
        var b = a ^ k;
        enc = enc + String.fromCharCode(b);
      }
      return enc;
    }
  };

  async function applogout() {
    let status = "";
    if (localStorage.getItem("mobile") === "On") status = "Off";
    else if (localStorage.getItem("mobile") === "Off") status = "On";

    var mainuser2 = jsEncode.encode("mamapr", 125);

    axios.post('https://excellentdairy.com/dairy/php/cust/appsettings.php', {
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
      status: status
    }).then(function sample(response) {
      if (response.data.trim() === "updated.") {
        if (localStorage.getItem("mobile") === "On") {
          notify(t("box.mobile_off_done"));
          localStorage.setItem("mobile", "Off");
        } else if (localStorage.getItem("mobile") === "Off") {
          notify(t("box.mobile_on_done"));
          localStorage.setItem("mobile", "On");
        }
        handledeleteclose();
      } else {
        notifyerror(t("common.try_again"));
      }
    }).catch(err => {
      console.log(err);
      notifyerror(t("common.try_again"));
    });
  }

  async function updatepass() {
    var mainuser2 = jsEncode.encode("mamapr", 125);

    axios.post('https://excellentdairy.com/dairy/php/cust/updatepass.php', {
      mainuser: localStorage.getItem("contact"),
      mainuser2: mainuser2,
      pass: input.pass
    }).then(function sample(response) {
      if (response.data.trim() === "updated.") {
        notify(t("box.password_updated"));
        handlechpassclose();
      } else {
        notifyerror(t("common.try_again"));
      }
    }).catch(err => {
      console.log(err);
      notifyerror(t("common.try_again"));
    });
  }

  const openanydesk = () => {
    window.open('https://anydesk.com/en/downloads/windows', '_blank', 'noopener,noreferrer');
  };

  const openteam = () => {
    window.open('https://www.teamviewer.com/en-us/content/free-download-with-license-options/', '_blank', 'noopener,noreferrer');
  };

  const ACTIONS = {
    member_master: { headKey: "dash.boxes.member_master", submenu: "customer", extra: () => setNewcustsource("dash") },
    sangh_master: { headKey: "dash.boxes.sangh_master", submenu: "sangh" },
    ratib_customer: { headKey: "dash.boxes.ratib_customer", submenu: "ratibmaster" },
    khadya_dealer: { headKey: "dash.boxes.khadya_dealer", submenu: "khparty" },
    rate_sangh: { headKey: "dash.boxes.rate_sangh", submenu: "ratetablesangh", headOverrideKey: "head.rate_sangh" },
    rate_kendra: { headKey: "dash.boxes.rate_kendra", submenu: "ratetable", headOverrideKey: "head.rate_kendra" },
    setting: { headKey: "dash.boxes.setting", submenu: "settings" },
    bank_master: { headKey: "dash.boxes.bank_master", submenu: "bank" },

    sanklan: { headKey: "tran.boxes.sanklan", submenu: "sanklan", extra: () => setSanksource("tran") },
    sanghvikri: { headKey: "tran.boxes.sangh_vikri", submenu: "sanghvikri" },
    ratibvikri: { headKey: "tran.boxes.ratib_vikri", submenu: "ratibvikri" },
    khadya_kharidi: { headKey: "tran.boxes.khadya_kharidi", submenu: "kpur" },
    khadya_vikri: { headKey: "tran.boxes.khadya_vikri", submenu: "ksale" },
    uchal: { headKey: "tran.boxes.uchal", submenu: "uchal" },
    retanmedi: { headKey: "tran.boxes.retanmedi", submenu: "retanmedi" },
    shares: { headKey: "tran.boxes.shares", submenu: "shares" },

    thevvatap: { headKey: "other.boxes.thevvatap", submenu: "thevvatap" },
    bonus: { headKey: "other.boxes.bonus", submenu: "bonus" },

    auditnew: { headKey: "audit.boxes.audit_account", submenu: "auditnew" },
    auditentry: { headKey: "audit.boxes.audit_entry", submenu: "auditentry" },
    rojkird: { headKey: "audit.boxes.rojkird", submenu: "rojkird" },
    khatevahi: { headKey: "audit.boxes.khatevahi", submenu: "khatevahi" },
    terij: { headKey: "audit.boxes.terij", submenu: "terij" },
    vyapari: { headKey: "audit.boxes.vyapari", submenu: "vyapari" },
    profitloss: { headKey: "audit.boxes.profitloss", submenu: "profitloss" },
    taleband: { headKey: "audit.boxes.taleband", submenu: "taleband" },

    bill: { headKey: "reports.boxes.bill", submenu: "bill" },
    pregister: { headKey: "reports.boxes.payment_register", submenu: "pregister" },
    bankreport: { headKey: "reports.boxes.bank_payment_report", submenu: "bankreport" },
    account: { headKey: "reports.boxes.member_account", submenu: "account" },
    sanklanreport: { headKey: "reports.boxes.sanklan_report", submenu: "sanklanreport" },
    vikrireport: { headKey: "reports.boxes.sangh_ratib_report", submenu: "vikrireport" },
    khadyaadvreport: { headKey: "reports.boxes.khadya_advance_report", submenu: "khadyaadvreport" },
    itrreports: { headKey: "reports.boxes.other_reports", submenu: "itrreports" },

    anydesk: { headKey: "extra.boxes.anydesk", action: openanydesk },
    teamviewer: { headKey: "extra.boxes.teamviewer", action: openteam },
    appsettings: { headKey: "extra.boxes.mobile_app_settings", submenu: "appsettings", extra: handledelete },
    changepass: { headKey: "extra.boxes.change_password", submenu: "changepass", extra: handlechpass },
    settings: { headKey: "extra.boxes.settings", submenu: "settings" },
    mobileuser: { headKey: "extra.boxes.mobile_user", submenu: "mobileuser" },
  };

  const handleclickbox = () => {
    const cfg = ACTIONS[props.action];
    if (!cfg) return;

    props.visibility?.();

    if (props.action === "dynamic_sangh_name") {
      const nm = localStorage.getItem("sanghkname") || "";
      if (nm) {
        setHeadname(nm);
        props.setsubmenu?.(nm);
      }
      return;
    }

    if (cfg.headText) setHeadname(cfg.headText);
    else if (cfg.headOverrideKey) setHeadname(t(cfg.headOverrideKey));
    else if (cfg.headKey) setHeadname(t(cfg.headKey));

    if (cfg.submenu) props.setsubmenu?.(cfg.submenu);

    if (typeof cfg.extra === "function") cfg.extra();

    if (typeof cfg.action === "function") cfg.action();
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        hidden={true}
        ref={refdelete}
        data-bs-target="#appsettings"
      />

      <div className="modal fade" id="appsettings" tabIndex="-1" role="dialog" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title"></h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refdeleteclose} aria-label="Close" />
            </div>

            <div className="modal-body">
              <h4 className="modal-title">
                {localStorage.getItem("mobile") === "On"
                  ? t("box.mobile_off_question")
                  : t("box.mobile_on_question")}
              </h4>

              <div className='helpmain'>
                <img className='smallimg' src={Status} alt="" />
                <span className="heading2">
                  {t("box.current_status")} - {localStorage.getItem("mobile")}
                </span>
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handledeleteclose}>
                {t("common.close")}
              </button>
              <button type="button" className="btn btn-danger" onClick={applogout}>
                {t("common.ok")}
              </button>
            </div>
          </div>
        </div>
      </div>

      <button
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        hidden={true}
        ref={refchpass}
        data-bs-target="#chngpass"
      />

      <div className="modal fade" id="chngpass" tabIndex="-1" role="dialog" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title"></h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refchpassclose} aria-label="Close" />
            </div>

            <div className="modal-body">
              <h4 className="modal-title">{t("box.enter_new_password")}</h4>
              <div className='helpmain'>
                <img className='smallimg' src={Status} alt="" />
                <input
                  onChange={handleChange}
                  type="number"
                  className="form-control"
                  id="pass"
                  name="pass"
                  value={input.pass}
                  autoComplete='off'
                />
              </div>
            </div>

            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handlechpassclose}>
                {t("common.close")}
              </button>
              <button type="button" className="btn btn-danger" onClick={updatepass}>
                {t("common.ok")}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div onClick={handleclickbox} className="aboutiq">
        <div style={{ background: props.background }} className="box">
          {props.img}
        </div>
        <span>{props.head}</span>
      </div>
    </>
  )
}

export default Box